export default function CTASection() {
  return (
    <section className="relative w-full py-28 md:py-36 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20online%20shopping%20concept%20with%20a%20laptop%20tablet%20and%20smartphone%20displaying%20fashion%20ecommerce%20interfaces%20surrounded%20by%20carefully%20styled%20clothing%20items%20and%20accessories%20on%20a%20warm%20cream%20minimalist%20desk%20setup%20soft%20ambient%20studio%20lighting%20with%20gentle%20diffused%20glow%20bright%20clean%20aesthetic&width=1600&height=800&seq=cta-backdrop-fresh-v2&orientation=landscape"
          alt="Shop Superbuy Spreadsheet Products"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
              Ready to shop?
            </h2>
            <p className="mt-4 text-base md:text-lg text-white/80 max-w-md">
              Access the full superbuy spreadsheet and start finding your next favorite piece today.
            </p>
          </div>
          <div className="flex flex-col items-start gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-8 py-4 bg-white text-foreground-900 text-sm font-semibold rounded-full hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer group"
            >
              Buy It Now
              <span className="w-7 h-7 flex items-center justify-center bg-foreground-900 text-white rounded-full group-hover:bg-primary-500 transition-colors">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
            <p className="text-xs text-white/60 max-w-xs">
              Browse thousands of verified products across 14+ categories on Kaspreadsheet
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}